export default __webpack_public_path__ + "static/media/loss-icon.e16f2a20.svg";